// extracted by mini-css-extract-plugin
module.exports = {"footerMenu__title":"c9_s2","footerMenu__items":"c9_s3","footerMenu__item":"c9_s4","footerMenu__icon":"c9_s5","footerMenu__links":"c9_s6","footerMenu__link":"c9_s7"};